// extracted by mini-css-extract-plugin
export default {"wrap":"RE-z","fullWidth":"SE-z","hideOnDesktop":"TE-z","content":"UE-z","hasOpenedNav":"VE-z","crumbsList":"WE-z","dropdownsWrap":"XE-z"};